import { useApi } from './useApi';
import { AllCategoriesURL, getMessagesURL } from '../utils/constants';
import { useQuery } from '@tanstack/react-query';
import { IMessage } from '@interfaces';
import i18n from '../i18n';

const useMessaging = () => {
  const { apiPrivate } = useApi();

  const getAllMessages = async (): Promise<IMessage[]> => {
    const lang = i18n.language || 'ar';
    const { data } = await apiPrivate.get(getMessagesURL, {
      params: { lang }
    });
    return data;
  };

  const allMessagesQuery = () =>
    useQuery({
      queryKey: [getMessagesURL],
      queryFn: getAllMessages,
    });

  return { allMessagesQuery };
};

export { useMessaging };
